<template>
  <div class="clearfix">
    <div class="clearfix breadcrumb">
      <ElBreadcrumb class="container breadcrumb_line">
        <ElBreadcrumbItem to="/"> 首页</ElBreadcrumbItem>
        <ElBreadcrumbItem>{{ title }}</ElBreadcrumbItem>
      </ElBreadcrumb>
    </div>
    <div class="clearfix container default_content">
      <div class="main_content">
        <h1 class="main_content_title animated fadeInRight">
          <i class="fas fa-bookmark" aria-hidden="true"
            ><span>{{ title }}</span></i
          >
        </h1>
        <div v-html="content" class="animated fadeInUp"></div>
      </div>
    </div>
  </div>
</template>
<script>
import util from "@libs/util";
import model from "@libs/model";
export default {
  name: "about",
  data() {
    return {
      title: "关于我们",
      content: "",
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.channelID = this.$route.params.channelID;
      this.title = model.GetChannelName(this.channelID);
      util.title(this.title);
      model.GetChannelIDSingePage(this.channelID, true).then((response) => {
        if (response.data.status == 1) {
          this.content = response.data.ItemExt.Content;
          if (!(process.env.NODE_ENV === "production")) {
            let re = /\/public\/apss.qhnu.edu.cn\/uploader/gi;
            this.content = this.content.replace(
              re,
              "http://apss.qhnu.edu.cn/public/apss.qhnu.edu.cn/uploader"
            );
          }
        }
      });
    },
  },
};
</script>
